import { render, staticRenderFns } from "./item-right.vue?vue&type=template&id=19d390d8&scoped=true&"
import script from "./item-right.vue?vue&type=script&lang=ts&"
export * from "./item-right.vue?vue&type=script&lang=ts&"
import style0 from "./item-right.vue?vue&type=style&index=0&id=19d390d8&prod&lang=scss&scoped=true&"
import style1 from "./item-right.vue?vue&type=style&index=1&id=19d390d8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d390d8",
  null
  
)

export default component.exports